// removed by extract-text-webpack-plugin
module.exports = {"modalPegarLocales":"modal__modalPegarLocales___3UFyS","tabla-pegar-locales":"modal__tabla-pegar-locales___12P0T","btn-50-perc":"modal__btn-50-perc___erOt3","form__control-label":"modal__form__control-label___2idOu","form__error-message":"modal__form__error-message___3JK51","textAlignLeft":"modal__textAlignLeft___1Ce06"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/mantenedorLocales2/modal.css
// module id = 956
// module chunks = 0